<template>
  <div />
</template>

<script>
import * as _ from 'lodash'
import { ASSIST, EVENT } from '@src/games/constant'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import { GAMES } from '@state/modules/game'

export default {
  name: 'Assistant',
  props: {
    parent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_PLAY_MODE, PLAYS.GET_ACTIVE_SCENE_ID]),
    ...mapGetters(GAMES.NAME, [GAMES.GET_GAME_MODES]),
    gameMode() {
      return _.get(this.GET_GAME_MODES, `[${this.GET_PLAY_MODE}]`)
    },
    isEnabled() {
      const enabled = this.$route.query.assist
      return enabled ? enabled === 'true' : _.get(this.gameMode, `assist`, false)
    },
    scenes() {
      return _.get(this.parent, 'scenes')
    },
    assistDelay() {
      return _.get(this.GET_GAME_MODES[this.GET_PLAY_MODE], 'assistDelay', 1000)
    },
  },
  beforeMount() {
    this.$events.on(EVENT.PLAY_SCENE_ACTIVE, (params) => this.start(params))
    this.$events.on(ASSIST.SHOW, (params) => this.start(params))
  },
  beforeDestroy() {
    this.$events.off(EVENT.PLAY_SCENE_ACTIVE)
    this.$events.off(ASSIST.HIDE)
  },
  methods: {
    start({ scene, isForce = false }) {
      if (scene && scene.id && (isForce || this.isEnabled)) {
        this.$log.debug(
          'assist : started scene id is ',
          scene.id,
          ', isEnabled : ',
          this.isEnabled,
          ', isForce : ',
          isForce
        )

        if (!isForce && _.get(scene.$el, 'dataset.assist') === 'false') {
          return
        }

        this.assistTimeout = setTimeout(() => {
          const elements = scene.$el.querySelectorAll('[data-assist="focus"]')
          this.$log.debug('assist : searched element number : ', elements.length)

          if (elements.length > 0) {
            this.$events.emit(ASSIST.START)

            for (const element of elements) {
              element.classList.add('on')
              element.parentElement.classList.add('on')
            }
          }
        }, this.assistDelay)
      } else {
        clearTimeout(this.assistTimeout)
      }
    },
  },
}
</script>

<style>
.assist-overlay {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 40;
  opacity: 0;
}
</style>
